import styled, { css } from "styled-components";
import { AiOutlineCheckCircle } from "react-icons/ai";

type ContainerProps = {
  isErrored: boolean;
  isFocused: boolean;
  disabled: boolean;
};

type LabelTextProps = {
  labelActivated: boolean;
};

export const Container = styled.label<ContainerProps>`
  background: white;
  border-radius: 5px;
  border: 1px solid ${({ theme }) => theme.colors.lightGray};
  width: 100%;
  display: flex;
  align-items: center;
  color: ${({ theme }) => theme.colors.gray};

  padding: 8px 12px 8px 12px;
  height: 50px;
  transition: border-color 0.5s, color 0.5s;

  svg {
    color: ${({ theme }) => theme.colors.gray};

    path.b {
      color: ${({ theme }) => theme.colors.gray};
      fill: ${({ theme }) => theme.colors.gray};
    }
  }

  ${(props) =>
    props.isErrored &&
    css`
      border-color: #dc3545;
      svg {
        color: #dc3545;
        path {
          &.b {
            color: #dc3545;
            fill: #dc3545;
          }
        }
      }
    `}

  ${(props) =>
    props.isFocused &&
    css`
      border-color: ${({ theme }) => theme.colors.lightBlue};
      svg {
        color: ${({ theme }) => theme.colors.lightBlue};

        path {
          &.b {
            color: ${({ theme }) => theme.colors.lightBlue};
            fill: ${({ theme }) => theme.colors.lightBlue};
          }
        }
      }
    `}

    ${(props) =>
    props.disabled &&
    css`
      border: 1px solid #c1c1c1;
      background-color: #eeeeee;
    `}

    svg:first-child {
    margin-right: 7px;
  }

  svg:last-child {
    margin-left: 7px;
  }

  div {
    display: flex;
    flex: 1;
    position: relative;
    flex-direction: column;

    span {
      color: ${({ theme }) => theme.colors.lightGray};
    }

    select {
      z-index: 1;
      flex: 1;
      background: transparent;
      border: 0;
      color: ${({ theme }) => theme.colors.gray};
      outline: none !important;
      padding: 0;
      margin-top: -5px;

      &::placeholder {
        color: #666360;
      }
    }
  }
`;

export const ErrorText = styled.span`
  color: #dc3545;
`;

export const LabelText = styled.span<LabelTextProps>`
  color: ${({ theme }) => theme.colors.mediumGray};
  position: absolute;
  z-index: 0;
  padding-top: 2px;
  transition: font-size 1s;
  transform: translateY(-3px);
  font-weight: 400;
  font-size: ${({ labelActivated }) =>
    labelActivated ? "0.625rem" : "0.875rem"};

  ${(props) =>
    props.labelActivated &&
    css`
      position: initial;
      transform: translateY(0);
    `}
`;

export const CorrectIcon = styled(AiOutlineCheckCircle)`
  color: #49c4d8 !important;
`;

export const Eye = styled.span`
  width: 40px;
  line-height: 1.75;
  font-size: 1.5rem;
  cursor: pointer;
  text-align: center;
  z-index: 1;
  user-select: none;
  color: ${({ theme }) => theme.colors.gray};
`;

export const Select = styled.select`
  border: none;
`;
